<template>
  <div class="yhc-component YhcRadio" :class="parentClass">
    <PrivateLabel v-if="label" :labelClass="labelClass" :label="label"></PrivateLabel>

    <div class="content">
      <el-radio-group @change="$_change" v-model="result">
        <el-radio :disabled="onlyRead" v-for="(v, k) in labelRadioOptions" :key="k" :label="v.value">{{
          v.label
        }}</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import propsMixin from './componentsData/propsMixin';
import methodsMixin3 from './componentsData/methodsMixin3';

import PrivateLabel from './componentsData/PrivateLabel.vue';

let identifierName = 'YhcRadio';

export default {
  name: identifierName,

  components: { PrivateLabel },
  mixins: [propsMixin, methodsMixin3],

  data() {
    return {
      result: this.value,
    };
  },

  props: {
    labelRadioOptions: {
      type: Array,
      required: true,
    },
    value: {
      type: [String, Boolean],
    },
  },

  computed: {},

  watch: {
    value(newVal, oldVal) {
      this.result = newVal;
    },
  },

  methods: {},
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import './componentsData/labelComponentCommonStyle';
.YhcRadio {
  @include labelCommon();
  .el-radio {
    margin: 8px;
    margin-left: 0;
    margin-right: 20px;
  }
}
</style>
